module.exports = __webpack_public_path__ + "static/media/image8.402a3814.webp";